module.exports = __webpack_public_path__ + "static/media/Unlockori.b8e77cad.ogg";